import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_ENFORCEMENT_DISRUPTED_REASONS_FETCH,
} from '../../../actions/actionTypes';

const enforcementDisruptedReasons = fetchReducerGenerator(
  [LINKS_MANAGEMENT_CLEAR],
  LINKS_MANAGEMENT_ENFORCEMENT_DISRUPTED_REASONS_FETCH
);

export default enforcementDisruptedReasons;
